export const PRICE_LABEL_CHILD_UNDER_7 = "prix-enfant-7ans";